"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellContext = void 0;
const react_1 = require("react");
exports.ShellContext = (0, react_1.createContext)({});
